import { scopedTranslation } from '@utils/I18n'

import { EditShiftDocument, type ShiftInput } from '@frontend/graphql/mutations/editShift.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

const t = scopedTranslation('author_shifts')

type EditShiftArgs = {
  id: string
  shift: ShiftInput
  onSuccess: () => void
  onError?: () => void
}

export const useEditShiftMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: EditShiftDocument,
    succeeded: (response) => Boolean(response?.editShift?.success),
    errorCode: 'EDIT_SHIFT_ERROR',
    failureMessage: t('errors.edit_failed'),
    extractErrors: (response) => response?.editShift?.errors,
  })

  return {
    editShift: ({ id, shift, onSuccess, onError }: EditShiftArgs) => run({ id, shift, onSuccess, onError }),
    isPending,
  }
}
